import Code from '@jetbrains/ring-ui/components/code/code'
import {Col, Row} from '@jetbrains/ring-ui/components/grid/grid'
import * as React from 'react'

import DifferenceMark from '../../DifferenceMark/DifferenceMark'

import styles from './UnknownRow.css'

type Props = {
  data1: {}
  data2: {}
  changed?: boolean | null | undefined
}

const renderData = (data: {}) => {
  if (data == null) {
    return <span />
  }

  let json

  try {
    json = JSON.stringify(data, null, 2)
  } catch (err) {
    // not a json
  }

  return json != null ? (
    <Code code={json} language="json" className={styles.code} />
  ) : (
    <span>{data.toString()}</span>
  )
}

function UnknownRow({data1, data2, changed}: Props) {
  return (
    <Row className={styles.row}>
      <Col xs={6}>
        <div className={styles.wrap}>
          {renderData(data1)}
          {changed === true && data1 != null && <DifferenceMark />}
        </div>
      </Col>
      <Col xs={6}>
        <div className={styles.wrap}>
          {renderData(data2)}
          {changed === true && data2 != null && <DifferenceMark />}
        </div>
      </Col>
    </Row>
  )
}

export default UnknownRow
